<template>
  <div id="root" class="toggle-menu">
    <menu-component whiteFont="true"></menu-component>
    <b-row class="full-height bg-img">
      <b-container class="alinov-header center-text">
        <b-row>
          <b-col>
            <h1>Agrícola</h1>
            <br/><br/>
            <a class="link-to-section" href="#studies">
              <i class="fas fa-chevron-circle-down"></i>
            </a>
          </b-col>
        </b-row>
      </b-container>
      <div id="studies" class="alinov-info-container">
        <b-container class="info">
          <b-row class="title">
	  <b-col>
             <h2>Agrícola</h2>
	      </b-col>
          </b-row>
          <b-row>
            <p> 
	    La agricultura es el conjunto de actividades económicas y técnicas relacionadas con el 
	   tratamiento del suelo y el cultivo de la tierra para la producción de alimentos. 
	   </p>
	  <p>
	  Alinov se reinventa día a día para convertirse en el mejor aliado de todos aquellos que 
	  alimentan a un país entero. Vivimos de cerca los retos para diseñar y ofrecer soluciones 
	  de alto impacto.
	  </p>
	  </b-col>
            <h4>¡CUÉNTANOS  QUE NECESITAS!</h4>
                <br/>
		<br/>
              <ul style="list-style-type:circle;">
	      	<li>
		SEMILLAS</li>
		<li>
		FERTILIZANTES</li>
		<li>
		AGROQUÍMICOS</li>
		<li>
		FERTILIZACIÓN CON DRONES</li>
		<li>
		ESTUDIOS DE SUELO Y AGUA</li>
		<li>
		FINACIAMIENTOS CON TASAS COMPETITIVAS Y PLAZOS A TU MEDIDA</li>
		</ul>
            </b-col>
          </b-row>

					<b-row class="title">
            <h4>¡CONTACTA A TU ASESOR ALINOV!</h4>
	         </b-row>
					<b-row>
           
 <b-col>
              <b-form @submit="onSubmit" @reset="onReset" v-if="show">
                <b-form-group id="name_gr" label="Nombre:" label-for="name_input">
                  <b-form-input
                    id="name_input"
                    type="text"
                    v-model="form.name"
                    required
                    placeholder="Escribe tu nombre"
                  />
                </b-form-group>
		<b-col sm="12" md="5">
                    <b-form-group
                      id="phone_gr"
                      label="Teléfono:"
                      label-for="phone_input"
                    >
                      <b-form-input
                        id="phone_input"
                        type="text"
                        v-model="form.phone"
                        required
                        placeholder="Escribe tu número de teléfono"
                      />
                    </b-form-group>
          	   <b-form-group id="subject_gr" label="Cultivo y Superficie:" label-for="subject_input">
                  <b-form-input
                    id="subject_input"
                    type="text"
                    v-model="form.subject"
                    required
                    placeholder="Escribe el tipo de cultivo y superficie"
                  />
                </b-form-group>
       
								<b-form-group>
									<b-form-textarea
										id="comment_ts"
										v-model="form.comment"
										placeholder="Agrega un comentario"
										rows="3"
										max-rows="6"
									/>
								</b-form-group>

								<b-button class="alinov" type="submit" variant="success">Enviar</b-button>
              </b-form>
            </b-col>
          </b-row>
        </b-container>
      </div>
    </b-row>
    <footer-component></footer-component>
  </div>
</template>

<script>
import Menu from "../shared/Menu.vue";
import Footer from "../shared/Footer.vue";
import {gmapApi} from 'vue2-google-maps';
import $ from 'jquery'

export default {
  name: "SoilStudy",
  components: {
    "menu-component": Menu,
    "footer-component": Footer
	},
	computed: {
    google: gmapApi
  },
  beforeMount() {
    $(function() {
      $('a.link-to-section').on('click', function(e) {
        e.preventDefault();
        $('html, body').animate({ scrollTop: $($(this).attr('href')).offset().top-80}, 500, 'linear');
      });
    });

    $(window).scroll(function() {
      var scroll = $(window).scrollTop();
      var headerHeight = 500;
      // $('.alinov-header').height() + 100;

      if (scroll >= headerHeight) {
        $(".toggle-menu .alinov-navbar:not(#nav-mobile)").addClass("white-bg");
        $(".toggle-menu .alinov-navbar:not(#nav-mobile)").removeClass("white-font");
      } else {
        $(".toggle-menu .alinov-navbar:not(#nav-mobile)").removeClass("white-bg");
        $(".toggle-menu .alinov-navbar:not(#nav-mobile)").addClass("white-font");
      }
    });
	},
	data() {
      return {
        user_id: process.env.VUE_APP_EMAIL_USER_ID,
        form: {
          email: '',
					name: '',
					comment: '',
					product: 'Suelo',
					quantity: '',
					type: null,
					address: ''
					},
					types: [{value: null, text: 'Seleccionar tipo'}, 
							{value: 'Básico', text: 'Básico'}, 
							{value: 'Completo', text: 'Completo'}
					],
					show: true,
					showMarker: false,
					marker: {
						position: {}
					}
      }
    },
    methods: {
			updateMarkerPosition(evt) {
				this.marker.position = {
					lat: evt.latLng.lat(),
					lng: evt.latLng.lng()
				};
        this.showMarker = true;
        
        // eslint-disable-next-line
				let geocoder = new google.maps.Geocoder;
				geocoder.geocode({'location': evt.latLng}, function(results) {
					$("#address_input").val(results[0].formatted_address)
				});
			},
      onSubmit(evt) {
				evt.preventDefault();

        this.form.address = $("#address_input").val();
        
        let comments = this.form.comment === ''? 'Sin comentarios':this.form.comment
        let request = `Se solicita un estudio de suelo de tipo ${this.form.type}. En la dirección: ${this.form.address}. Comentarios: ${comments}`

				var data = {
            service_id: 'gmail',
            template_id: 'template_pedido',
            user_id: this.user_id,
            template_params: {
                'from_email': this.form.email,
                'reply_to': this.form.email,
                'from_name': this.form.name,
                'phone': 'No aplica',
                'request': request
            }
        };
        
        $.ajax('https://api.emailjs.com/api/v1.0/email/send', {
            type: 'POST',
            data: JSON.stringify(data),
            contentType: 'application/json'
        }).done(function() {
            alert('¡Tu correo ha sido enviado!');
        }).fail(function() {
            alert('Ocurrió un error. Vuelte a intentarlo más tarde.');
        });
      },
      onReset(evt) {
        evt.preventDefault()
        /* Reset our form values */
        this.form.email = '';
				this.form.name = '';
				this.form.comment = '';
        this.form.type = null;
        /* Trick to reset/clear native browser form validation state */
        this.show = false;
        this.$nextTick(() => {
          this.show = true;
        })
			}
		}
};
</script>

<style lang="scss" scoped>
.full-height {
	background-image:linear-gradient( 
    rgba(0, 0, 0, 0.5), 
    rgba(0, 0, 0, 0.5) ), 
		url("../assets/images/agri3.jpg");

}

.alinov-info-container .info.container .row {
	h2 {
		font-size: 40px;
	}
}

.alinov-info-container .info.container .row.title {
	padding-top: 1rem;
}

.w-border {
	border-bottom: 1px solid rgba(0,0,0,0.1);
} 

.img-col .img-fluid {
	width: 80%;
}
</style>
